import React from 'react';
import MALogo from './LoginForm/MALogo';

const BuyPage = () => {
  const eventUrl = process.env.REACT_APP_MOTOAMERICA_BUY_CREDENTIALS_URL || 'https://www.motorsportreg.com/orgs/motoamerica';

  return (
  <div className="container">
    <MALogo showClose={true} />

   <div className="margin-top">
      <h2>Click the button to order more credentials at MotorsportReg</h2>
      <a href={eventUrl} target="_blank" className="btn btn-block btn-primary btn-lg">Buy MotoAmerica Credentials</a>
    </div>
  </div>
  )
};

export default BuyPage;



// WEBPACK FOOTER //
// ./src/components/BuyPage.js